import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from '@sparro/core/api/user/user.service';
import { ProjectService } from '@sparro/app/core/api/project/project.service';
import { BlogService } from '@sparro/api/blog/blog.service';
import { PublicationService } from '@sparro/api/publication/publication.service';

import { UniApiConfig } from '@sparro/app/core/config/api.config';
import { Blog } from '@sparro/app/core/models/blog.model';
import { Publication } from '@sparro/app/core/models/publication.model';
import { Project, ProjectOwner } from '@sparro/app/core/models/project.model';
import { User } from '@sparro/app/core/models/user.model';

export type PreviewPaneData = {
  uuid?: string;
  slug: string;
  entityType: string;
  projectVersion?: string;
};

export type MetaData = {
  owners: ProjectOwner[];
}

@Component({
  selector: 'app-preview-pane',
  templateUrl: './preview-pane.component.html',
  styleUrls: ['./preview-pane.component.scss']
})
export class PreviewPaneComponent implements OnInit {
  url: string;
  entityType: string;
  host: string;
  slug: string;
  owner: ProjectOwner[];
  user: User;
  entityCopyLink: string = '';
  sharedContent: Object;
  projectVersion: string = 'latest';
  entity: Blog | Publication | any;
  loading: boolean = true;
  showSection: boolean = false;
  isVerticallyScrollable: boolean = true;
  self: boolean = false;

  constructor(
    private publicationService: PublicationService,
    private blogService: BlogService,
    public dialogRef: MatDialogRef<PreviewPaneComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PreviewPaneData,
    private _apiConfig: UniApiConfig,
    private projectService: ProjectService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.entityType = this.data.entityType;
    this.slug = this.data.slug;
    this.entityCopyLink = this._apiConfig.copyLinkUrls.projectUrl;
    if (this.slug){
      this.getEntity();
    }
    if (this.entityType === 'projects') {
      this.projectVersion = this.data.projectVersion;
    }
    this.getUser();
  }

  getUser() {
    this.userService.userInitialized.subscribe(
      (initialized: boolean) => {
        if (initialized) {
          this.userService.user.subscribe(
            (user: User) => {
              this.user = user;
              this.loading = false;
            }
          );
        }
      }
    );
  }
  
  getEntity(): void {
    if (this.entityType === this._apiConfig.publicationUrl) {
      this.publicationService.getPublication(this.slug).subscribe(
        (response: Publication) => {
          this.entity = response;
          this.sharedContent = {
            title: this.entity.title,
            subtitle: this.entity.desc,
            cover_image: this.entity.cover_image?.url
          };
          this.loading = false;
        });
    } else if (this.entityType === this._apiConfig.blogUrl) {
      this.blogService.getBlog(this.slug).subscribe(
        (response: Blog) => {
          this.entity = response;
          this.loading = false;
        });
    } else if (this.entityType === this._apiConfig.projectUrl) {
      this.projectService.getProject(this.slug).subscribe(
        (response: Project) => {
          this.entity = response;
          this.sharedContent = {
            title: this.entity.content.title,
            subtitle: this.entity.content.desc,
            cover_image: this.entity.content.cover.media.url
          };
          this.loading = false;
        });
      this.projectService.getProjectMeta(this.slug).subscribe(
        (response: MetaData) => {
          this.owner = response.owners.filter((userObj) => {
            if (userObj.user && userObj.user != null) {
              return userObj;
            }
          });
          this.self = this.owner.some(owner => owner.user.id === this.user.id);
          this.loading = false;
        }
      );
    }
  }
}
